const {Component} = require("react");
const axios = require("axios");
const env = require("app/services/env");

class Form extends Component {

	constructor(props) {
		super(props);

		this.state = {
			message: null,
			loading: false,
			errors: null
		};

		this.is_loading = false;

	}

	get baseClassName() {
		return "form";
	}

	get className() {
		let classList = [this.baseClassName];

		if (this.state.loading) {
			classList.push("loading");
		}

		return classList.join(" ");
	}

	get actionUrl() {
		// ...
	}

	buildPayload(form) {
		let formData = new FormData(form);
		let cartId   = env.get("checkout.cart.products.guid");

		if (cartId !== null) {
			formData.append('cart_id', cartId);
		}

		return formData;
	}

	onSubmit = (e) => {
		e.preventDefault();
		this.performSubmit(e.target);
	};

	performSubmit(form) {

        if(this.is_loading === true) {
            return false;
        }

        this.is_loading = true;

		// Set as loading
		this.setState({loading: true});

		return axios.post(this.actionUrl, this.buildPayload(form))
			.then(response => {
                this.is_loading = false;
				this.onComplete(response.data);
				return response;
			})
			.catch(error => {
                this.is_loading = false;
				this.onError(error.response.data);
			});
	}

	onComplete(response) {
		this.setState({
			loading: false,
			message: response.message || this.state.message
		});
	}

	onError(response) {
		if (response.errors) {
			this.setState({
				errors: response.errors,
				loading: false,
			});
		}
	}

	renderMessage() {
		return (
			<div className="response">
				<div className="message" >{this.state.message}</div>
			</div>
		);
	}

	renderForm() {
		// ...
	}

	renderError(name, extraClass = null) {
		const className = "form-error" + (extraClass ? ` ${extraClass}` : "");

		if (this.state.errors && this.state.errors[name]) {
			return (<div className={className}>{this.state.errors[name][0]}</div>)
		}
	}

	renderBody() {
		return (
			<div ref={el => this.bodyElement = el} className="form-body">{this.renderForm()}</div>
		);
	}

	render() {
		return (
			<div className={this.className}>{this.renderBody()}</div>
		);
	}

}

module
	.exports = Form;
